import React, { useContext, useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { CoreContext } from '../../context/index.js';
import { selectCart } from '../../storeSelectors/cart.js';
import '../../utils/logToSlack.js';
import '../../animations--PMkOS0j.js';
import 'cookies-next';
import { S as SM_WIDTH } from '../../breakpoints-X1SKRYyW.js';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import { S as SHOPPING_CART } from '../../paths-ZKN3m62_.js';
import '../../payment-YC9H491Y.js';
import '../../index-nNbKOeeS.js';
import useHoverIntent from '../../hooks/useHoverIntent.js';
import useShowError from '../../hooks/useShowError.js';
import 'notistack';
import useWindowSize from '../../hooks/useWindowSize.js';
import 'lodash/get';
import '../../product-_pRduMz7.js';
import '../../helpers-kA_hdoOI.js';
import { s as sendCartEventAccor, a as sendViewItemListEventAccor } from '../../cart-SVV9q5Ln.js';
import 'lodash';
import useItemListName from '../../hooks/useItemListName.js';
import '../../utils/currency.js';
import 'next/server';
import '../../index-Oip0gjfj.js';
import { getCartSessionId } from '../../utils/cart.js';
import { w as withProviders } from '../../withProviders-l3mjYkR2.js';
import { M as MiniShoppingCartContent } from '../../MiniShoppingCartContent-tZZmT1oa.js';
import { s as sendCartEvent } from '../../cart-bEN0otWy.js';
import 'lodash/cloneDeep';
import '../../_commonjsHelpers-jjO7Zipk.js';
import '../../index-RkBJ48Nr.js';
import 'i18next';
import 'react-i18next';
import '../../index-SAqL6VZm.js';
import '../../utils/error.js';
import '../../serverErrors-_VHsjhgw.js';
import '../../utils/logger.js';
import '../../utils/logToRelic.js';
import '../../utils/product.js';
import '../../cookies-l-jEMp6P.js';
import '../../utils/cookies.js';
import '../../utils/isBot.js';
import '../../utils/dataRouteFormat.js';
import '../../MergeCarts-wo9UjKo5.js';
import '../../ProcessReactivateCart-fk5bSKoR.js';
import '../../requestsCollection-_VRM28HJ.js';
import '../../graphqlRequestClient-3KYHZKVm.js';
import 'graphql-request';
import '../../services/auth/index.js';
import '../../utils/fetchPolicyLookup.js';
import '../../utils/price.js';
import 'number-currency-format';
import '../../cart-Vtx0Wqgk.js';
import '../EmptyMessage/index.js';
import '../Button/index.js';
import '../../index-2586sEvh.js';
import '../CircularProgress/index.js';
import '../Link/index.js';
import 'next/link';
import '../../MiniShoppingCartSkeleton-U6EZ6VaK.js';
import '../../Skeleton-RKr5mJai.js';
import '../../ItemSkeleton-03cEVH7e.js';
import '../../MiniShoppingCartItem-UKpWU5t6.js';

const MiniShoppingCart = () => {
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { t: tHeading } = useTranslation('', { keyPrefix: '$common.$headings' });
    const { push } = useRouter();
    const { data: { locale, siteConfig: { productNameFilters, parentHotelCompany, siteName, accorTagging: { accorTaggingEnabled = false } = {}, }, }, useDispatch, useSelector, thunks: { cart: { getCart }, }, } = useContext(CoreContext);
    const dispatch = useDispatch();
    const cart = useSelector(selectCart);
    const windowSize = useWindowSize();
    const showError = useShowError();
    const quantity = cart.total_quantity;
    const isSmallScreen = Boolean(windowSize.width) && windowSize.width <= SM_WIDTH;
    const itemListName = useItemListName('mini basket');
    // Send cart_view event only on first hover
    const [hasNewCartItems, setHasNewCartItems] = useState(true);
    const [isHovering, intentRef] = useHoverIntent({ inDelay: 150, outDelay: 750 });
    const loadCartData = async () => {
        const cartSessionId = getCartSessionId();
        // Disable fetching data for small screen width
        if (isSmallScreen || !cartSessionId || cart.has_fetched)
            return;
        const resultAction = await dispatch(getCart({ cart_id: cartSessionId, accorTaggingEnabled }));
        if (getCart.rejected.match(resultAction)) {
            showError(resultAction.payload.errorMessage);
        }
    };
    const handleGoToShoppingCart = () => {
        push(`/${locale}${SHOPPING_CART}`);
    };
    const onMouseEnter = () => {
        if (isSmallScreen)
            return;
        loadCartData();
    };
    // reset hasNewCartItems when cart changes
    useEffect(() => {
        if (cart.items.length) {
            setHasNewCartItems(true);
        }
    }, [cart.items]);
    useEffect(() => {
        if (!isSmallScreen && isHovering && hasNewCartItems && cart.items.length) {
            if (accorTaggingEnabled) {
                sendCartEventAccor({
                    cart,
                    isViewCartEvent: true,
                    siteFilters: productNameFilters,
                    affiliation: parentHotelCompany,
                    brand: siteName,
                });
                sendViewItemListEventAccor({
                    cart,
                    siteFilters: productNameFilters,
                    brand: siteName,
                    itemListName,
                });
            }
            else {
                sendCartEvent({
                    cart,
                    locale: locale,
                    isViewCartEvent: true,
                    siteFilters: productNameFilters,
                    affiliation: parentHotelCompany,
                    brand: siteName,
                });
            }
            setHasNewCartItems(false);
        }
    }, [isHovering, cart.has_fetched]);
    return (React.createElement("div", { ref: intentRef, id: "shopping-bag", "aria-label": tLabel('miniShoppingCartAriaLabel'), onMouseEnter: onMouseEnter },
        React.createElement("button", { "data-testid": "button-shopping-bag", type: "button", className: "ab-icon button-shopping-bag button-reset", onClick: () => handleGoToShoppingCart() },
            React.createElement("span", { className: "icon-bag", title: tHeading('shoppingCart') }),
            Boolean(quantity) && (React.createElement("div", { className: "cart-items-amount", "data-testid": "cart-items-amount" },
                React.createElement("span", { className: "sr-only" },
                    tLabel('items'),
                    ":"),
                " ",
                quantity))),
        !isSmallScreen && isHovering && (React.createElement("div", { className: "drop-shopcart clear" },
            React.createElement(MiniShoppingCartContent, { isLoading: !cart.has_fetched && quantity > 0, cart: cart, quantity: quantity })))));
};
var MiniShoppingCart$1 = withProviders(MiniShoppingCart, { translation: true, snackbar: true });

export { MiniShoppingCartContent, MiniShoppingCart$1 as default };
//# sourceMappingURL=index.js.map
